// src/redux/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../utils/fetchWrapper";

export const updateSettings = createAsyncThunk(
  "setting/setting",
  async ({ payload, projectId, folderName }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const body = { ...payload, folderName };
      const { data } = await fetchWrapper.put(
        `setting/${projectId}`,
        body,
        { withCredentials: true }
      );

      return fulfillWithValue(data);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const settingSlice = createSlice({
  name: "setting",
  initialState: {
    settings: {},
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    logout: (state) => {
      state.settings = null;
    },
    clear: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSettings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = payload.message;
      })
      .addCase(updateSettings.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload.message;
      });
  },
});

export const { logout, clear } = settingSlice.actions;
export default settingSlice.reducer;
